<template>
  <a-select
    :disabled="disabled"
    :multiple="false"
    :placeholder="placeholder"
    :value="value"
    allow-clear
    option-filter-prop="title"
    show-search
    @change="onChange"
    :virtual="false"
  >
    <a-select-option v-for="item in records" :key="item.id" :title="item.name" :value="item.id">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import RepoService from "@/views/material/repo/repo.service";

/**
 * 仓库选择器
 *
 * 使用方式:
 * <repo-select v-model:value="formRef.repoId"></repo-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "RepoSelect",
  props: {
    value: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const onChange = async (id) => {
      emit("update:value", id);
      emit("change", id);
    };
    const { data: records, run, loading } = RepoService.useSimpleListApi();
    onMounted(async () => {
      await run();
    });

    return {
      records,
      onChange,
      loading,
    };
  },
});
</script>
